export const DESC_SETTING = Symbol('DESC_SETTING');
